import { tenantProjectInfo } from "../models/TenantProjectInfo";
import { projectConfig } from "../project-info/projectConfig";

// used for values in projectConfig.js
export const pickProjectConfigValue = (key) => {
  const tenantValue = tenantProjectInfo.getValue(key);
  if (tenantValue !== null) {
    return tenantValue;
  }
  return projectConfig[key];
};

// used for values in eventConfig.js
export const pickEventConfigValue = (key, fallback) => {
  const tenantValue = tenantProjectInfo.getValue(key);
  if (tenantValue !== null) {
    return tenantValue;
  }
  return fallback; // maybe use eventConfig, however we have it organized elsewhere and currently are utilizing that instead of re-organizing it
};

